<template>
  <div style="display: flex;flex-direction: column;align-items: center;justify-content: flex-start;width: 100%">
    <div id="mainContentWrapper"
         style="width: 100%;min-width:1000px;display: flex;flex-direction: column;align-items: center;justify-content: flex-start"
         bgScroll="none">
      <Header/>
      <Banner/>
      <div class="title-con">
        <div class="w-line"/>
        <div v-if="this.$route.name === 'contactus'" class="title-con-right">
          <div style="font-size:24px;margin-top: 10px;">联系我们</div>
          <div style="line-height:31px;font-size: large">Contact Us</div>
        </div>
        <div v-else class="title-con-right">
          <div style="font-size:24px;margin-top: 10px;">关于我们</div>
          <div style="line-height:31px;font-size: large">About Us</div>
        </div>
      </div>
      <div v-if="this.$route.name === 'contactus'" class="cell-row" style="width: 1000px;">
        <img src="../../public/img/amap.png" alt="amap" style="margin-left: 30px;">
        <div class="cell-column" style="margin-left: 30px;">
          <div class="cell-row">
            <span style="white-space:pre">公司邮箱：</span>
            <span class="span-text">clo2health@163.com</span>
          </div>
          <div class="cell-row">
            <span style="white-space:pre">公司地址：</span>
            <span class="span-text">重庆市江津区双福新区联东U谷5号楼</span>
          </div>
          <div class="cell-row">
            <span style="white-space:pre">联系电话：</span>
            <span class="span-text">023-47897989</span>
          </div>
          <div class="cell-row">
            <span style="white-space:pre">淘宝店铺：</span>
            <span class="span-text">https://shop530138975.taobao.com/</span>
          </div>
        </div>
      </div>
      <div v-else class="cell-row" style="width: 1000px;">
        <div class="cell-column" style="margin-left: 30px;">
          <p>
            在新冠疫情蔓延之际，市场上缺少有效的民用空气消杀产品。常用的75%酒精、84消毒液的消杀对象局限为物体表面，不适用于空气消杀。为弥补市场空白，助力疫情防控，我司自主研发出基于ClO2的克罗兔®系列空气消杀产品。产品主要成分ClO2是经世界卫生组织（WHO）、世界粮食组织（FAO）以及食品添加剂专家委员会（JECFA）认证的A1级消毒剂，适用于自来水、物体表面、食品、医疗器具、瓜果蔬菜、空气环境的杀菌消毒，并先后用于“9.11”事件后炭疽热疫源、“非典”病毒及埃博拉病毒的消杀，为国家卫健委在新冠肺炎疫情期间推荐使用的空气消杀剂。
          </p>
        </div>
        <img src="../../public/img/31020489.jpeg" alt="amap" style="margin-left: 30px;width: 474px;height: 316px;">
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from "@/components/Header"
import Banner from "@/components/Banner";
import Footer from "@/components/Footer";

export default {
  name: "DetailPageContent",
  components: {
    Footer,
    Banner,
    Header
  }
}
</script>

<style scoped>
.title-con {
  width: 1000px;
  height: auto;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 30px 0 0 0;
  margin-bottom: 30px;
}

.title-con .title-con-right {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-left: 20px;
}

.cell-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.cell-column {
  flex: 1;
  width: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.w-line {
  display: block;
  margin: 0;
  margin-left: -3px;
  padding: 0;
  width: 1px;
  height: 64px;
  font-size: 0;
  border-left-width: 6px;
  border-left-style: solid;
  border-left-color: #444444;
  -moz-box-shadow: 0 0 0 transparent;
  -webkit-box-shadow: 0 0 0 transparent;
  -ms-box-shadow: 0 0 0 transparent;
  -o-box-shadow: 0 0 0 transparent;
  box-shadow: 0 0 0 transparent;
}

span {
  display: block;
  margin-bottom: 28px;
  color: #666;
  font-size: 20px;
  font-family: 'Microsoft YaHei';
  font-weight: 400;
  text-decoration: none;
  font-style: normal;
}

.span-text {
  width: 400px;
}
p {
  padding: 0;
  margin: 0;
  font-family: 'Microsoft YaHei';
  color: #666;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  text-decoration: none;
  text-align: left;
  line-height: 44px;
  word-wrap: break-word;
  word-break: normal;
}
</style>